import axiosClient from './axiosClient';

export const getLenders = () => axiosClient.get('/api/lenders');

export const createLender = (payload) => axiosClient.post('/api/lenders', payload);

export const updateLender = (id, payload) => axiosClient.put(`/api/lenders/${id}`, payload);

export const deleteLender = (id) => axiosClient.delete(`/api/lenders/${id}`);
